module.exports = __webpack_public_path__ + "e447c86ee5f00a8c74ae97d85a8b5442.svg";